module.exports = __webpack_public_path__ + "img/thanhlong1.ec904eef.jpg";